import { FC } from 'react'
import cx from 'classnames'
import { LoginMethodFormProps } from 'src/forms/LoginMethodForm'
import { useTheme } from 'styled-components'

import { ActionButtonProps } from '../ActionButton'
import { LinkProps } from '../Link'
import { ActionButtonVariant } from '../ActionButton/styled'

import * as SC from './styled'

export type LoginMethodFormBlockProps = {
  className?: string
  blockTitle?: string
  form?: LoginMethodFormProps
  button?: ActionButtonProps
  backLink?: LinkProps
  topBackLink?: LinkProps
  email?: string
}

const LoginMethodFormBlock: FC<LoginMethodFormBlockProps> = ({
  className,
  form,
  blockTitle,
  button,
  backLink,
  topBackLink,
  email,
}) => {
  const theme = useTheme()
  return (
    <>
      {topBackLink && email && (
        <SC.TopBlock>
          <SC.TopLink {...topBackLink}>
            <SC.BackLinkIcon
              icon="chevronLeft"
              height={14}
              color={theme.colors.bluePrimary}
            />
            {topBackLink.text}
          </SC.TopLink>
          <SC.Email>{email}</SC.Email>
        </SC.TopBlock>
      )}
      <SC.Block className={cx('LoginMethodFormBlock', className)}>
        {blockTitle && <SC.Title $centered>{blockTitle}</SC.Title>}
        <SC.Wrapper>
          {form && <SC.Form {...form} />}
          {button && (
            <SC.Button {...button} variant={ActionButtonVariant.quaternary} />
          )}
        </SC.Wrapper>
        {backLink && (
          <SC._Link {...backLink}>
            <SC.BackLinkIcon
              icon="chevronLeft"
              height={14}
              color={theme.colors.bluePrimary}
            />
            {backLink.text}
          </SC._Link>
        )}
      </SC.Block>
    </>
  )
}

export default LoginMethodFormBlock
